module.exports = __webpack_public_path__ + "static/media/banco_sat.20b94dfe.svg";